import React, { useState } from 'react';
import { Input, Button, Typography, Space, Spin, Divider, message } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone, UserOutlined, LockOutlined, LoginOutlined, ExperimentOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { MAINVERSION } from '../appsettings';
import { login } from '../../services/authService';

const Authlogin = () => {
  const navigate = useNavigate();

  const [txtusername, setTxtUsername] = useState("");
  const [txtpassword, setTxtPassword] = useState("");
  const [loading, setLoading] = useState(false);

  function handleChange_username(event) {
    setTxtUsername(event.target.value);
  }

  function handleChange_password(event) {
    setTxtPassword(event.target.value);
  }

  async function onClickLogin() {
    if (txtusername.trim() === "") {
      message.error('Please Enter Username.');
      return;
    }

    if (txtpassword.trim() === "") {
      message.error('Please Enter Password.');
      return;
    }

    setLoading(true);

    try {
      await login(txtusername.trim(), txtpassword.trim());
      navigate('/dash');
    } catch (error) {
      message.error(error.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  function onClickReset() {
    navigate('/resetpassword');
  }

  function handleKeyPress(event) {
    if (event.key === 'Enter') {
      onClickLogin();
    }
  }

  return (
    <>
      <style>
        {`
          .login-container {
            min-height: 100vh;
            display: flex;
            background: #f1f8e9;
            overflow: hidden;
            position: relative;
          }

          /* Left Side - Visual Branding */
          .login-visual {
            flex: 1.4;
            position: relative;
            overflow: hidden;
            background: #1b5e20;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: white;
            padding: 60px;
          }

          .login-visual::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: url('agro_login_bg_1778692821388.png');
            background-size: cover;
            background-position: center;
            opacity: 0.6;
            filter: saturate(1.2) contrast(1.1);
          }

          .login-visual::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(135deg, rgba(69, 161, 134, 0.8) 0%, rgba(69, 161, 134, 0.4) 100%);
          }

          .visual-content {
            position: relative;
            z-index: 2;
            text-align: center;
            max-width: 500px;
          }

          .agro-logo-container {
            background:;
            backdrop-filter: blur(10px);
            padding: 20px;
            border-radius: 30px;
            display: inline-block;
            margin-bottom: 40px;
            border: 1px solid #c8e6c9;
            box-shadow: 0 20px 40px rgba(0,0,0,0.2);
          }

          .agro-logo-icon {
            font-size: 60px;
            color: #81c784;
          }

          .agro-title {
            font-size: 48px;
            font-weight: 800;
            letter-spacing: -1.5px;
            margin-bottom: 15px;
            line-height: 1.1;
          }

          .agro-tagline {
            font-size: 18px;
            opacity: 0.9;
            line-height: 1.6;
            color: #c8e6c9;
          }

          /* Right Side - Form */
          .login-form-side {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 40px;
            background: #f1f8e9;
            z-index: 2;
          }

          .login-card {
            width: 100%;
            max-width: 420px;
            background: rgba(255, 255, 255, 0.9);
            backdrop-filter: blur(20px);
            padding: 50px 40px;
            border-radius: 32px;
            box-shadow: 0 25px 50px rgba(0,0,0,0.08);
            border: 1px solid white;
          }

          .login-card-header {
            text-align: center;
            margin-bottom: 40px;
          }

          .login-card-title {
            font-size: 32px;
            font-weight: 800;
            color: #347965;
            margin-bottom: 10px;
            letter-spacing: -1px;
          }

          .login-card-subtitle {
            color: #667e6c;
            font-size: 15px;
          }

          .agro-input {
            height: 52px !important;
            border-radius: 14px !important;
            border: 2px solid #e8f5e9 !important;
            background: #fafdfa !important;
            font-size: 15px !important;
            transition: all 0.3s ease !important;
          }

          .agro-input:hover, .agro-input:focus {
            border-color: #347965 !important;
            background: white !important;
            box-shadow: 0 0 0 4px rgba(76, 175, 80, 0.1) !important;
          }

          .login-btn {
            height: 56px !important;
            border-radius: 14px !important;
            background: linear-gradient(135deg, #347965 0%, #347965 100%) !important;
            border: none !important;
            font-size: 17px !important;
            font-weight: 700 !important;
            box-shadow: 0 10px 25px rgba(46, 125, 50, 0.3) !important;
            margin-top: 15px !important;
          }

          .login-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 15px 30px rgba(46, 125, 50, 0.4) !important;
            filter: brightness(1.1);
          }

          .login-btn:active {
            transform: translateY(0);
          }

          .forgot-pw {
            text-align: center;
            margin-top: 25px;
          }

          .forgot-pw a {
            color: #2e7d32;
            font-weight: 600;
            transition: color 0.2s;
          }

          .forgot-pw a:hover {
            color: #1b5e20;
            text-decoration: underline;
          }

          .login-footer {
            margin-top: 40px;
            padding-top: 30px;
            border-top: 1px solid #e8f5e9;
            text-align: center;
            font-size: 12px;
            color: #90a495;
          }

          @media (max-width: 1024px) {
            .login-visual { display: none; }
            .login-form-side { background: linear-gradient(135deg, #f1f8e9 0%, #e8f5e9 100%); }
          }
        `}
      </style>

      <div className="login-container">
        {/* Visual Side */}
        <div className="login-visual">
          <div className="visual-content">
            <div className="agro-logo-container">
              <img src="/mainlogo.png" style={{height:200,width:200}}/>
            </div>
            <div className="agro-title">AgroLand Management System</div>
            <div className="agro-tagline">
              Smart agriculture platform for efficient farm operations and sustainable growth.
            </div>
          </div>
        </div>

        {/* Form Side */}
        <div className="login-form-side">
          <div className="login-card">
            <div className="login-card-header">
              <div className="login-card-title">Sign In</div>
              <div className="login-card-subtitle">Enter your credentials to manage your farm</div>
            </div>

            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <div>
                <Typography.Text style={{ marginBottom: 8, display: 'block', fontWeight: 600, color: '#2e7d32', fontSize: '13px' }}>
                  USERNAME
                </Typography.Text>
                <Input
                  placeholder="Enter username"
                  prefix={<UserOutlined style={{ color: '#81c784', marginRight: 8 }} />}
                  onChange={handleChange_username}
                  onKeyPress={handleKeyPress}
                  className="agro-input"
                  value={txtusername}
                />
              </div>

              <div>
                <Typography.Text style={{ marginBottom: 8, display: 'block', fontWeight: 600, color: '#2e7d32', fontSize: '13px' }}>
                  PASSWORD
                </Typography.Text>
                <Input.Password
                  placeholder="Enter password"
                  prefix={<LockOutlined style={{ color: '#81c784', marginRight: 8 }} />}
                  iconRender={(visible) => (visible ? <EyeTwoTone twoToneColor="#2e7d32" /> : <EyeInvisibleOutlined />)}
                  onChange={handleChange_password}
                  onKeyPress={handleKeyPress}
                  className="agro-input"
                  value={txtpassword}
                />
              </div>

              <Button
                type="primary"
                onClick={onClickLogin}
                className="login-btn"
                block
                disabled={loading}
                icon={!loading && <LoginOutlined />}
              >
                {loading ? <Spin size="small" /> : 'Login'}
              </Button>
            </Space>

            <div className="forgot-pw">
              <Typography.Text style={{ color: '#90a495' }}>
                Lost access? <a onClick={onClickReset}>Request Reset</a>
              </Typography.Text>
            </div>

            <div className="login-footer">
              <div>ALMS System v{MAINVERSION}</div>
              <div style={{ marginTop: 8 }}>
                Powered by <a href="https://dsmit.lk" style={{ color: '#2e7d32', fontWeight: 600 }}>DSM IT (PVT) LTD</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Authlogin;
